import { render, staticRenderFns } from "./TriageQuestion.vue?vue&type=template&id=261f0976&scoped=true&"
import script from "./TriageQuestion.vue?vue&type=script&lang=js&"
export * from "./TriageQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TriageQuestion.vue?vue&type=style&index=0&id=261f0976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f0976",
  null
  
)

export default component.exports